var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6,5.4 L10,5.4 L8.6,4 L4.4,4 C3.623,4 3.007,4.623 3.007,5.4 L3,13.8 C3,14.577 3.623,15.2 4.4,15.2 L15.6,15.2 C16.377,15.2 17,14.577 17,13.8 L17,6.8 C17,6.023 16.377,5.4 15.6,5.4 L15.6,5.4 Z M14.9,11 L12.8,11 L12.8,13.1 L11.4,13.1 L11.4,11 L9.3,11 L9.3,9.6 L11.4,9.6 L11.4,7.5 L12.8,7.5 L12.8,9.6 L14.9,9.6 L14.9,11 L14.9,11 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Add-File",
    transform: "translate(-3.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#0c1030",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add-file.f0a72f4c653f12136b37e202fd0dacb5.svg";
export { ForwardRef as ReactComponent };